<template>
  <div class="bj">
    <!-- 头部 -->
    <Top id="topbox" />
    <!-- 主体 -->
    <div class="indexmain clearfix">
      <!-- 左侧 -->
      <div class="leftmain fl">
        <div class="clearfix" style="position: relative">
          <!-- 浏览器提示开始 -->
          <div
            class="alert fade alert-simple alert-info alert-dismissible text-left font__family-montserrat font__size-16 font__weight-light brk-library-rendered rendered show"
            v-show="tipShow" role="alert" data-brk-library="component__alert">
            <button type="button" class="close font__size-18" data-dismiss="alert" @click="closeTip">
              <span aria-hidden="true">
                <i class="fa fa-times blue-cross"></i>
              </span>
              <!-- <span class="sr-only">Close</span> -->
            </button>
            <i class="start-icon fa fa-info-circle faa-shake animated"></i>
            建议浏览器：ie9+、火狐、谷歌
          </div>
          <!-- 浏览器提示结束 -->
          <div class="middle_top fl">
            <div class="fl">
              <div class="list_title">文献</div>
              <div class="list_num_bg">
                <div id="num1" class="counter-value fl span_bj timer" :data-to="num0"></div>
                <!-- <div id="num1" class="counter-value fl span_bj timer" data-to="19"></div> -->
                <span>+（万）篇</span>
                <div class="clear"></div>
              </div>
            </div>
            <div class="line fl">
              <img src="@/assets/imgs/interval.png" />
            </div>
            <div class="clear"></div>
          </div>
          <div class="middle_top fl">
            <div class="fl">
              <a class="list_title_color" href="/#/db/cgit">数据</a>
              <div class="list_num_bg">
                <div id="num2" class="counter-value fl span_bj timer" :data-to="num1"></div>
                <!-- <div id="num1" class="counter-value fl span_bj timer" data-to="26853"></div> -->
                <!-- <div id="num1" class="counter-value fl span_bj timer" >26853</div> -->
                <span>+（亿）条</span>
                <div class="clear"></div>
              </div>
            </div>
            <div class="line fl">
              <img src="@/assets/imgs/interval.png" />
            </div>
            <div class="clear"></div>
          </div>
          <div class="middle_top fl">
            <div class="fl">
              <a class="list_title_color" href="/#/lit/channel?uid=8004">报告</a>
              <div class="list_num">
                <div class="counter-value fl span_bj timer" :data-to="num2"></div>
                <span class="unit">篇</span>
                <div class="clear"></div>
              </div>
            </div>
            <div class="line fl">
              <img src="@/assets/imgs/interval.png" />
            </div>
            <div class="clear"></div>
          </div>
          <div class="middle_top fl">
            <div class="fl">
              <a class="list_title_color" href="/#/lit/channel?uid=8007">法规</a>
              <div class="list_num">
                <div class="counter-value fl span_bj timer" :data-to="num3"></div>
                <span class="unit">篇</span>
                <div class="clear"></div>
              </div>
            </div>
            <div class="line fl">
              <img src="@/assets/imgs/interval.png" />
            </div>
            <div class="clear"></div>
          </div>
          <div class="middle_top fl">
            <div class="fl">
              <a class="list_title_color" href="/#/lit/channel?uid=8010">规划方案</a>
              <div class="list_num">
                <div class="counter-value fl span_bj timer" :data-to="num4"></div>
                <span class="unit">个</span>
                <div class="clear"></div>
              </div>
            </div>
            <div class="line fl">
              <img src="@/assets/imgs/interval.png" />
            </div>
            <div class="clear"></div>
          </div>
          <div class="middle_top fl">
            <div class="fl">
              <a class="list_title_color" href="/#/lit/channel?uid=8008">项目</a>
              <div class="list_num">
                <div class="counter-value fl span_bj timer" :data-to="num5"></div>
                <span class="unit">个</span>
                <div class="clear"></div>
              </div>
            </div>
            <div class="line fl">
              <img src="@/assets/imgs/interval.png" />
            </div>
            <div class="clear"></div>
          </div>
          <div class="middle_top fl">
            <div class="fl">
              <a class="list_title_color" href="/#/lit/channel?uid=8012">园区</a>
              <div class="list_num">
                <div class="counter-value fl span_bj timer" :data-to="num6"></div>
                <span class="unit">个</span>
                <div class="clear"></div>
              </div>
            </div>
            <div class="line fl">
              <img src="@/assets/imgs/interval.png" />
            </div>
            <div class="clear"></div>
          </div>
          <div class="middle_top fl">
            <div class="fl">
              <a class="list_title_color" href="/#/lit/channel2?uid=8014&subuid=8004&attr=安徽">省市</a>
              <div class="list_num">
                <div class="counter-value fl span_bj timer" :data-to="num7"></div>
                <span class="unit">个</span>
                <div class="clear"></div>
              </div>
            </div>
            <div class="line fl">
              <img src="@/assets/imgs/interval.png" />
            </div>
            <div class="clear"></div>
          </div>
          <div class="middle_top fl">
            <div class="fl">
              <a class="list_title_color" href="/#/lit/channel2?uid=8013&subuid=8004&attr=阿富汗">国别</a>
              <div class="list_num">
                <div class="counter-value fl span_bj timer" :data-to="num8"></div>
                <span class="unit">个</span>
                <div class="clear"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 世界地图 -->
        <div class="map_box">
          <div class="map_title">
            <router-link class="map_title_a" :to="{ path: '/' + maptodb + '' }">{{ maptitle }}</router-link>
          </div>
          <div class="box_sx">
            <ul>
              <!-- CGIT检索 -->
              <li v-if="isLengedCGIT" style="margin-right: 1.5vw">
                单位：亿美元
              </li>
              <li v-if="isLenged" style="margin-right: 1.5vw">
                单位：百万美元
              </li>
              <router-link class="PowerIndicators" :to="{ path: '/powerIndicators?政府首脑的产生方式' }" v-if="isPowerIndicators"
                target="_blank">指标解释</router-link>
              <!-- <a :href="'#' + $route.path + 'powerIndicators#' + 'zhnegfu'">指标说明</a> -->
              <li>
                <div class="dropdown">
                  <el-select :popper-append-to-body="false" filterable popper-class="homeselect"
                    v-model="countrysCgitvalue" multiple collapse-tags placeholder="全部经济体" size="medium">
                    <!-- @change="cgitselectchange"
                    filterable-->
                    <el-option v-for="item in countrys" :key="item.value" :label="item.name"
                      :value="item.value"></el-option>
                  </el-select>
                </div>
              </li>
              <!-- 贸易库检索 -->
              <!-- <li v-if="istrade">
                <div class="dropdown">
                  <el-select
                    :popper-append-to-body="false"
                    popper-class="homeselect"
                    v-model="countrysTradevalue"
                    multiple
                    collapse-tags
                    @change="Tradeselectchange"
                    size="medium"
                  >
                    <el-option
                      v-for="item in countrysTrade"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </li>
              <li v-if="istrade">单位：百万美元</li>-->
            </ul>
          </div>
          <div class="clear"></div>
          <div class="map_main">
            <div class="mapchart" :style="{ height: '54vh', width: '100%' }" ref="mainmap" id="mainmap"></div>
          </div>
        </div>
        <!-- 左侧底部 -->
        <div class="bottomleft">
          <ul class="tab_map">
            <li id="map1">
              <a @click="loadcgitmap()">
                <img src="@/assets/imgs/M_map_1.png" width="100%" />
                <p>中国对外直接投资</p>
              </a>
            </li>
            <li id="map2">
              <a @click="loadtrademap()">
                <img src="@/assets/imgs/M_map_2.png" width="100%" />
                <p>中国货物贸易出口</p>
              </a>
            </li>
            <li id="map3">
              <a @click="loadpoliticsmap()">
                <img src="@/assets/imgs/M_map_3.png" width="100%" />
                <p>政府首脑的产生方式</p>
              </a>
            </li>
            <li id="map4">
              <a @click="loadbusinessmap()">
                <img src="@/assets/imgs/M_map_4.png" width="100%" />
                <!-- <p>世界各国营商便利度得分</p> -->
                <p>世行营商环境成熟度(B-READY)指标</p>
              </a>
            </li>
            <li id="map5">
              <a @click="loadyuanqumap()">
                <img src="@/assets/imgs/M_map_5.png" width="100%" />
                <p>中国境外经贸合作区</p>
              </a>
            </li>
          </ul>
        </div>
        <!-- <div class="perch"></div> -->
      </div>
      <!-- 右侧 -->
      <div class="rightmain fr">
        <!-- 1 -->
        <div class="background_border mb">
          <div class="clearfix">
            <ul class="fl clearfix">
              <li id="part1li1" class="fl">
                <a class="btn_a btn_a_on" @mouseover="changerightpart1li(1, 'tj')" href="/#/lit/channel?uid=8000">推荐</a>
              </li>
              <li id="part1li2" class="fl">
                <a class="btn_a" @mouseover="changerightpart1li(2, 'bg')" href="/#/lit/channel?uid=8004">报告</a>
              </li>
              <li id="part1li3" class="fl">
                <a class="btn_a" @mouseover="changerightpart1li(3, 'zx')" href="/#/lit/channel?uid=8009">动态</a>
              </li>
              <li id="part1li4" class="fl">
                <a class="btn_a" @mouseover="changerightpart1li(4, 'al')" href="/#/lit/channel?uid=8005">案例</a>
              </li>
            </ul>
            <div class="pageup fr">
              <a id="btn2">
                <img src="@/assets/imgs/top.png" />
              </a>
              <a id="btn1">
                <img src="@/assets/imgs/down.png" />
              </a>
            </div>
          </div>

          <div class="panel panel-default">
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12">
                  <!-- 推荐 -->
                  <div class="rightpart1div">
                    <ul class="two_ul rightpart1" v-show="rightpart1tab == 'tj'">
                      <li class="two_li" v-for="item in docListTJAll" :key="item.code">
                        <a target="_blank" :title="item.title" class="a_tiile fl" :href="'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnid=' +
                          item.chnid +
                          '&leafid=' +
                          item.leafid +
                          '&docid=' +
                          item.code.substring(4, item.code.length) +
                          '&version=YDYL'
                          ">{{ item.title | titleellipsis }}</a>
                        <span class="fr">{{
                          item.deliveddate.substring(0, 10)
                        }}</span>
                      </li>
                    </ul>
                  </div>
                  <!-- 报告 -->
                  <div class="rightpart1div">
                    <ul class="two_ul rightpart1" v-show="rightpart1tab == 'bg'">
                      <li class="two_li" v-for="item in docListBGAll" :key="item.code">
                        <a target="_blank" :title="item.title" class="a_tiile fl" :href="'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnid=' +
                          item.chnid +
                          '&leafid=' +
                          item.leafid +
                          '&docid=' +
                          item.code.substring(4, item.code.length) +
                          '&uid=' +
                          item.uid +
                          '&version=YDYL'
                          ">{{ item.title | titleellipsis }}</a>
                        <span class="fr">{{
                          item.deliveddate.substring(0, 10)
                        }}</span>
                      </li>
                    </ul>
                  </div>
                  <!-- 资讯 -->
                  <div class="rightpart1div">
                    <ul class="two_ul rightpart1" v-show="rightpart1tab == 'zx'">
                      <li class="two_li" v-for="item in docListZXAll" :key="item.code">
                        <a target="_blank" :title="item.title" class="a_tiile fl" :href="'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnid=' +
                          item.chnid +
                          '&leafid=' +
                          item.leafid +
                          '&docid=' +
                          item.code.substring(4, item.code.length) +
                          '&uid=' +
                          item.uid +
                          '&version=YDYL'
                          ">{{ item.title | titleellipsis }}</a>
                        <span class="fr">{{
                          item.deliveddate.substring(0, 10)
                        }}</span>
                      </li>
                    </ul>
                  </div>
                  <!-- 案例 -->
                  <div class="rightpart1div">
                    <ul class="two_ul rightpart1" v-show="rightpart1tab == 'al'">
                      <li class="two_li" v-for="item in docListALAll" :key="item.code">
                        <a target="_blank" :title="item.title" class="a_tiile fl" :href="'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnid=' +
                          item.chnid +
                          '&leafid=' +
                          item.leafid +
                          '&docid=' +
                          item.code.substring(4, item.code.length) +
                          '&uid=' +
                          item.uid +
                          '&version=YDYL'
                          ">{{ item.title | titleellipsis }}</a>
                        <span class="fr">{{
                          item.deliveddate.substring(0, 10)
                        }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="clear"></div>
        </div>
        <!-- 2 -->
        <div class="background_border mb">
          <div class="title_right_box">
            <div class="clearfix" style="position: absolute">
              <div class="title_h2 fl">
                <h2>各省市境外经贸合作园区分布情况</h2>
              </div>
              <ul class="btn_ul fl clearfix">
                <li id="part2li1" class="fl">
                  <a class="btn_b btn_b_on" @mouseover="changerightpart2li(1, 'ss')"
                    @click="changerightpart2li(1, 'ss')">中国省市</a>
                </li>
                <li id="part2li2" class="fl">
                  <a class="btn_a" @mouseover="changerightpart2li(2, 'gb')" @click="changerightpart2li(2, 'gb')">国家</a>
                </li>
              </ul>
              <!-- <div class="pageup fr" v-show="false">
                <a @click="rightpart2top">
                  <img src="@/assets/imgs/top.png" />
                </a>
                <a @click="rightpart2down">
                  <img src="@/assets/imgs/down.png" />
                </a>
              </div>-->
            </div>
            <div class="provinces">
              <div class="provincesq" style="height: 100%; overflow: auto">
                <div v-show="rightpart2tab == 'ss'">
                  <c-chart id="chart2_1" ref="chart2_1" :option="chart2_1"
                    :style="{ height: '600px', width: '430px' }"></c-chart>
                </div>
                <div v-show="rightpart2tab == 'gb'">
                  <c-chart id="chart2_2" ref="chart2_2" :option="chart2_2"
                    :style="{ height: '1200px', width: '430px' }"></c-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 3 -->
        <div class="background_border mb">
          <div class="title_h2 fl">
            <h2>热词</h2>
          </div>
          <div class="rsc_box">
            <c-chart id="worldcloud" ref="worldcloud" :option="optionworldcloud"
              :style="{ height: '100%', width: '100%' }"></c-chart>
          </div>
        </div>
      </div>
      <!-- 底部提示框 -->
      <!-- <div class="advise">建议浏览器：ie9+、火狐、谷歌</div> -->
    </div>
    <!-- 右2下钻弹出框 -->
    <div class="historySupBox" :style="{ display: boxDisplay }">
      <div class="maskBox" @click="closeAlert"></div>
      <div class="historyAlertBox">
        <!-- <div class="historyAlertBox_close" @click="closeAlert"></div> -->
        <div class="historyAlertBox_data"></div>
        <div class="historyAlertBox_main" id="historyContainer" style="width: 100%; height: 100%">
          <cChart id="chart2" :option="chart2" :style="{ margin: '0 auto', height: '225px', width: '400px' }"></cChart>
        </div>
      </div>
    </div>
    <!-- 飘窗 -->
    <!-- <div class="window" v-if="windowShow">
      <div class="close" @click="close">X</div>
      <a href="http://ydylzj.drcnet.com.cn/" target="_blank">
        <img src="@/assets/imgs/window.png" />
      </a>
    </div> -->
  </div>
</template>

<script>
import Top from "../components/top.vue";
// import "../../node_modules/echarts/map/js/world3.js";
// import "../utils/word2";
import {
  initCGITmap,
  initTrademap,
  initPoliticsmap,
  initBusinessmap,
  initYuanqumap,
} from "../assets/js/indexworldmap.js";

import cChart from "../views/Database/cgit_chart.vue";
import SelectTree from "@/components/treeSelect.vue";
import { api } from "@/require/api";
import { count } from "../assets/js/timepeople.js";
import "../assets/js/pagescroll.js";
import "echarts-wordcloud";
import "../assets/js/rem.js";

export default {
  components: {
    Top,
    cChart,
    SelectTree,
  },
  data() {
    var that = this;
    return {
      tipShow: true,
      // 文献、数据、报告、法规、规划方案、项目、园区、省市、国别
      num0: 0,
      num1: 0,
      num2: 0,
      num3: 0,
      num4: 0,
      num5: 0,
      num6: 0,
      num7: 0,
      num8: 0,
      maptodb: "db/cgit", //地图标题跳转地址
      maptitle: "中国全球投资跟踪数据库", //地图标题
      geoCoordMapdataCGIT: {}, //流向图
      geoCoordMapdataTrade: {},
      geoCoordMapdataYuanqu: {},
      nameMap: {},
      CGITworldData: [], // 中国全球投资数据
      TradeworldData: [], // 中国对外贸易库
      PoliticsworldData: [], // 政治数据库
      DbusinessworldData: [], // 营商数据库
      YuanworldData: [], // 园区数据库

      //cgit区域
      countrysvalue: "",
      countryid: "", //下拉所有区域value

      // 获取的下拉数据
      isLenged: true,
      isLengedCGIT: false,
      isPowerIndicators: false,
      countrys: [], ///下拉值
      countrysCgit: [],
      countrysTrade: [],
      countrysPolitics: [],
      countrysDbusiness: [],
      countrysYuanqu: [],

      oldcountrys: [], //用来存储上一次的数据

      countrysCgitvalue: [],
      countrysTradevalue: [],
      //贸易库进出口总数
      iorename: "出口",
      tradeselect: [
        {
          value: "进出口总数",
          label: "进出口总数",
        },
        {
          value: "进口",
          label: "进口",
        },
        {
          value: "出口",
          label: "出口",
        },
      ],
      value: "",

      //政治库
      currentPage: 1,
      pageSize: 12,
      docListBGAll: [], //各栏目取12条数据
      docListZXAll: [],
      docListALAll: [],
      docListTJAll: [],
      rightpart1tabindex: 1, //右上1应该是哪个栏目的上下翻按钮
      rightpart1tab: "tj", //右上1显示哪个栏目下的ul列表
      rightpart2tab: "ss", //右上1显示哪个栏目下的ul列表

      part2_1Data: [], //右2省市
      part2_2Data: [], //右2国家
      part2_1Datasub: [], //柱图下钻二级值-因为接口一次性返回了，所以先保存，下钻时使用
      part2_2Datasub: [],
      rightpart2_1x1: 0, //右2省市上下翻第一个值坐标
      rightpart2_1x2: 5, //右2省市上下翻第二个值坐标
      rightpart2_2x1: 0, //右2国家上下翻第一个值坐标
      rightpart2_2x2: 5, //右2国家上下翻第二个值坐标
      part2_1max: 100,
      part2_2max: 100,
      part2_1Value: [], //右2省市所有Value
      part2_1Data: [], //右2省市所有Data
      part2_2Value: [], //右2国家所有Value
      part2_2Data: [], //右2国家所有Data
      part2_1CurrentValue: [], //右2省市当前显示的柱图
      part2_1CurrentData: [], //右2省市当前显示的柱图
      part2_2CurrentValue: [], //右2国家当前显示的柱图
      part2_2CurrentData: [], //右2国家当前显示的柱图
      boxDisplay: "none", //柱图下钻弹出框

      //右2省市
      chart2_1: {
        tooltip: {
          //trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            return params.name + "：" + params.value + "个";
          },
        },
        grid: [
          {
            height: "100%",
            left: "11%",
            // top: '0%',
            bottom: "0%",
          },
        ],
        yAxis: [
          {
            data: [],
            axisLine: {
              //y轴
              show: false,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLabel: {
              color: "#fff",
            },
          },
          {
            axisTick: "none",
            axisLine: "none",
            data: [],
          },
        ],
        xAxis: [
          {
            scale: true,
            show: false,
            type: "value",
          },
        ],
        series: [
          {
            name: "",
            type: "bar",
            itemStyle: {
              normal: {
                // color: new echarts.graphic.LinearGradient(
                //   1,
                //   0,
                //   0,
                //   0,
                //   [
                //     {
                //       offset: 0,
                //       color: "#0099ff" // 0% 处的颜色
                //     },
                //     {
                //       offset: 1,
                //       color: "#3366ff" // 100% 处的颜色
                //     }
                //   ],
                //   false
                // )
                // barBorderRadius: 14 //圆角
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: function (params) {
                  let colorList = [["#bb5d0c", "#fcb51c"]];
                  for (let i = 0; i < 22; i++) {
                    colorList.unshift(["#0099ff", "#3366ff"]);
                  }
                  var index = params.dataIndex;
                  if (params.dataIndex >= colorList.length) {
                    index = params.dataIndex - colorList.length;
                  }
                  return new that.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: colorList[index][0],
                    },
                    {
                      offset: 1,
                      color: colorList[index][1],
                    },
                  ]);
                },
              },
            },
            barWidth: 12,
            data: [],
            z: 2,
          },
          {
            name: "白框",
            type: "bar",
            yAxisIndex: 1,
            barGap: "-100%",
            data: [],
            barWidth: 12,
            itemStyle: {
              normal: {
                opacity: 0,
                //color: "#0e2147"
              },
            },
            z: 1,
          },
        ],
      },
      //右2国家
      chart2_2: {
        tooltip: {
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            return params.name + "：" + params.value + "个";
          },
        },
        grid: [
          {
            height: "100%",
            left: "16%",
            // top: '0%',
            bottom: "0%",
          },
        ],
        yAxis: [
          {
            data: [],
            axisLine: {
              //y轴
              show: false,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLabel: {
              color: "#fff",
            },
          },
          {
            axisTick: "none",
            axisLine: "none",
            data: [],
          },
        ],
        xAxis: [
          {
            show: false,
            scale: true,
            type: "value",
          },
        ],
        series: [
          {
            name: "",
            type: "bar",
            itemStyle: {
              normal: {
                color: new that.$echarts.graphic.LinearGradient(
                  1,
                  0,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: "#0099ff", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#3366ff", // 100% 处的颜色
                    },
                  ],
                  false
                ),
                // barBorderRadius: 14 //圆角
              },
            },
            barWidth: 12,
            data: [],
            z: 2,
          },
          {
            name: "白框",
            type: "bar",
            yAxisIndex: 1,
            barGap: "-100%",
            data: [],
            barWidth: 12,
            itemStyle: {
              normal: {
                opacity: 0,
                // color: "#0e2147"
              },
            },
            z: 1,
          },
        ],
      },
      //下钻
      chart2: {
        title: [
          {
            text: "",
            textStyle: {
              fontSize: 14,
              color: "#00BDFF",
            },
            left: "center",
            top: "top",
            bottom: "5%",
          },
        ],
        tooltip: {
          trigger: "item",
          //formatter: "{a} <br/>{b} : {c} ({d}%)"
          formatter: function (params) {
            return params.name + "：" + params.value + "个";
          },
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "50%",
            center: ["50%", "58%"],
            clockwise: false,
            data: [],
            label: {
              normal: {
                textStyle: {
                  color: "#fff",
                  fontSize: 12,
                },
              },
            },
          },
        ],
        color: [
          "#A0CE3A",
          "#31C5C0",
          "#1E9BD1",
          "#0F347B",
          "#585247",
          "#7F6AAD",
          "#009D85",
          "#00acee",
          "#52cdd5",
          "#79d9f1",
          "#a7e7ff",
          "#c8efff",
        ],
      },
      //热搜词
      optionworldcloud: {
        // maxFontSize: 5,  // 最大fontSize，用来控制weightFactor，默认60
        // minFontSize: 2,  // 最小fontSize，用来控制weightFactor，默认12
        left: -10,
        top: -10,
        tooltip: {
          show: true,
        },
        series: [
          {
            type: "wordCloud",
            gridSize: 0,
            // shape: "diamond",
            sizeRange: [11, 28],
            width: "96%",
            height: "96%",
            textStyle: {
              normal: {
                // color: function() {
                //   return (
                //     "rgb(" +
                //     [
                //       Math.round(Math.random() * 500),
                //       Math.round(Math.random() * 400),
                //       Math.round(Math.random() * 300)
                //     ].join(",") +
                //     ")"
                //   );
                // }
                color: function (v) {
                  let color = [
                    "#d5b719",
                    "#71b5fe",
                    "#2bcaf4",
                    "#9d35d0",
                    "#f34a4a",
                    "#347fca",
                    "#3ca074",
                    "#ff885b",
                    "#72b0d9",
                  ];
                  let num = Math.floor(Math.random() * 8);
                  return color[num];
                },
              },
              emphasis: {
                shadowBlur: 10,
                shadowColor: "#333",
              },
            },
            data: [],
          },
        ],
      },
      windowShow: true
    };
  },
  filters: {
    //文章标题截取
    titleellipsis(value) {
      if (!value) return "";
      if (value.length > 25) {
        return value.slice(0, 25) + "...";
      }
      return value;
    },
  },
  created() {
    this.loadselectcountryCgit(); //加载cgit国家下拉
    this.loadselectcountryTrade(); //加载贸易数据库下拉
    this.loadselectcountryPolitics(); //加载政治数据库下拉
    this.loadselectcountryDbusiness(); //加载营商数据库下拉
    this.loadselectcountryYuanqu(); //加载园区数据库下拉

    this.loadgeoCoordMapdataCGIT(); //geo
    this.loadgeoCoordMapdataTrade();
    this.loadgeoCoordMapdataYuanqu();
    this.loadnameMapdata();
  },
  mounted() {
    this.loadnum(); //上方数字
    this.loaddocsBG(); //右上1全部数据
    this.loaddocsZX();
    this.loaddocsAL();
    this.loaddocsTJ();

    // this.drawcgitMap(); // 开始绘制CGIT
    // loadcgitmap
    // this.loadcgitmap(); //地图流向(默认显示cgit)

    this.getCityZoneList(); //右2省市
    this.getCountryZoneList(); //右2国家
    this.wordsByWebChannels(); //右3热搜词

    setTimeout(() => {
      this.loadpagescroll(); //右1自动翻、上下翻
    }, 120);
  },
  methods: {
    close() {
      this.windowShow = false
    },
    // 关闭提示框
    closeTip() {
      this.tipShow = false;
    },
    //cgit库检索改变（注销）
    cgitselectchange(value) {
      //     let allValues = []
      //     for (let item of this.countrys) {
      //         allValues.push(item.value)
      //     }
      //     // 用来储存上一次的值，可以进行对比
      //     const oldVal = this.oldcountrys.length === 1 ? this.oldcountrys[0]:[]
      //     // 若是全部选择
      //     if (value.includes(0)){
      //       this.countrysCgitvalue = allValues
      //     }
      //     // 取消全部选中  上次有 当前没有 表示取消全选
      //     if (oldVal.includes(0) && !value.includes(0)){
      //       this.countrysCgitvalue = []
      //     }
      //     // 点击非全部选中  需要排除全部选中 以及 当前点击的选项
      //     // 新老数据都有全部选中
      //     if (oldVal.includes(0) && value.includes(0)) {
      //         const index = value.indexOf(0)
      //         value.splice(index, 1) // 排除全选选项
      //         this.countrysCgitvalue = value
      //     }
      //       //全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
      //     if (!oldVal.includes(0) && !value.includes(0)) {
      //         console.log(11)
      //         if (value.length === allValues.length - 1){
      //           this.countrysCgitvalue = [0].concat(value)
      //         }
      //     }
      //      //储存当前最后的结果 作为下次的老数据
      //     this.oldcountrys[0] = this.countrysCgitvalue
      //     this.countryid = this.oldcountrys[0].toString(); //给下拉赋选择的值
      //     this.drawcgitMap();
    },
    //贸易库检索改变
    Tradeselectchange(value) {
      if (value.length > 1) {
        for (let i = 0; i < value.length; i++) {
          if (value[i] === 0) {
            this.$message({
              message: "全部经济体不能与国家同时选择",
              type: "warning",
            });
            return;
          }
        }
        this.countryid = value.join(","); //给下拉赋选择的值
        this.drawtradeMap();
      } else {
        this.countryid = value.join(","); //给下拉赋选择的值
        this.drawtradeMap();
      }
    },
    //数字
    async loadnum() {
      const { code, data } = await api.get("HomePageController/getStatistics");
      if (code === 0) {
        this.num0 = data[0].count.toString().slice(0, 2);
        this.num1 = data[1].count.toString().slice(-10, -4);
        this.num2 = data[2].count;
        this.num3 = data[3].count;
        this.num4 = data[4].count;
        this.num5 = data[5].count;
        this.num6 = data[6].count;
        this.num7 = data[7].count;
        this.num8 = data[8].count;
        //不知道为什么，不设置延时页面总是0，因此设置了个延时
        setTimeout(() => {
          $(".timer").each(count);
        }, 1);
      }
    },
    //右1上下翻
    loadpagescroll() {
      $(".rightpart1div").Scroll({
        line: 1,
        autoline: 1,
        speed: 500,
        timer: 2500,
        up: "btn1",
        down: "btn2",
      });
    },
    //获取右1全部数据列表-报告
    async loaddocsBG() {
      const { code, data } = await api.get(
        "HomePageController/getPageChannelDocumentsByUId",
        {
          uid: "8004",
          curPage: this.currentPage,
          pageSize: this.pageSize,
        }
      );
      if (code === 0) {
        this.docListBGAll = data.data;
      }
    },
    //获取右1全部数据列表-资讯
    async loaddocsZX() {
      const { code, data } = await api.get(
        "HomePageController/getPageChannelDocumentsByUId",
        {
          uid: "8009",
          curPage: this.currentPage,
          pageSize: this.pageSize,
        }
      );
      if (code === 0) {
        this.docListZXAll = data.data;
      }
    },
    //获取右1全部数据列表-案例
    async loaddocsAL() {
      const { code, data } = await api.get(
        "HomePageController/getPageChannelDocumentsByUId",
        {
          uid: "8005",
          curPage: this.currentPage,
          pageSize: this.pageSize,
        }
      );
      if (code === 0) {
        this.docListALAll = data.data;
      }
    },
    //获取右1全部数据列表-推荐
    async loaddocsTJ() {
      //8b0806eb2bb3468084a0c7707e7804d5/f0e06248151c1b7634138768862d880f5f00187f70
      let logguid = document.cookie.replace(
        /(?:(?:^|.*;\s*)8b0806eb2bb3468084a0c7707e7804d5\s*\=\s*([^;]*).*$)|^.*$/,
        "$1"
      );
      const { code, data } = await api.get("HomePageController/getRecommend", {
        mark: "ydyl",
        rec_num: 12,
        guid: logguid,
      });
      if (code === 0) {
        this.docListTJAll = data;
      }
    },
    //加载cgit国家下拉
    async loadselectcountryCgit() {
      const { code, data } = await api.get("HomePageController/getDbInfo", {
        dbid: 1,
      });
      if (code === 0) {
        this.countrysCgit = data.countrys; //下拉值
        this.loadcgitmap(); //加载数据
      }
    },
    //加载贸易数据库下拉
    async loadselectcountryTrade() {
      const { code, data } = await api.get(
        "HomePageController/dimension/getTradeDimensions"
      );
      if (code === 0) {
        this.countrysTrade = data.states; //下拉值
      }
    },
    //加载政治数据库下拉
    async loadselectcountryPolitics() {
      const { code, data } = await api.get(
        "HomePageController/getIndicatorCountrys "
      );
      if (code === 0) {
        this.countrysPolitics = data; //下拉值
      }
    },
    //加载营商数据库下拉
    // async loadselectcountryDbusiness() {
    //   const { code, data } = await api.get(
    //     "HomePageController/getTimesAndCountrys"
    //   );
    //   if (code === 0) {
    //     // 洛杉矶 纽约 中国香港
    //     Dbusiness3 = data.countryNames;
    //     let Dbusiness1, Dbusiness2, Dbusiness3;
    //     Dbusiness3.forEach((item, index, arr) => {
    //       if (item.name === "洛杉矶") {
    //         arr.splice(index, 1);
    //       }
    //     });
    //     Dbusiness3.forEach((item, index, arr) => {
    //       if (item.name === "纽约") {
    //         arr.splice(index, 1);
    //       }
    //     });
    //     Dbusiness3.forEach((item, index, arr) => {
    //       if (item.name === "中国香港") {
    //         arr.splice(index, 1);
    //       }
    //     });
    //     this.countrysDbusiness = Dbusiness3;
    //     // this.countrysDbusiness = data.countryNames;
    //   }
    // },
    async loadselectcountryDbusiness() {
      var { code, data } = await api.get(
        "/doingBusiness2026Controller/getTimesAndCountrys"
      );
      if (code === 0) {
        // 洛杉矶 纽约 中国香港
        // Dbusiness3 = data.countryNames;
        // let Dbusiness1, Dbusiness2, Dbusiness3;
        // Dbusiness3.forEach((item, index, arr) => {
        //   if (item.name === "洛杉矶") {
        //     arr.splice(index, 1);
        //   }
        // });
        // Dbusiness3.forEach((item, index, arr) => {
        //   if (item.name === "纽约") {
        //     arr.splice(index, 1);
        //   }
        // });
        // Dbusiness3.forEach((item, index, arr) => {
        //   if (item.name === "中国香港") {
        //     arr.splice(index, 1);
        //   }
        // });
        if (code === 0) {
          this.countrysmodel = "选择经济体";
          if (data.countryNames[0].name == "全部经济体") //因为接口中有"全部经济体"，因此需要去掉
            data.countryNames.splice(0, 1);
          this.countrysDbusiness = data.countryNames; //下拉值
        }
        // this.countrysDbusiness = Dbusiness3;
        // this.countrysDbusiness = data.countryNames;
      }
    },
    //加载园区数据库下拉
    async loadselectcountryYuanqu() {
      const { code, data } = await api.get(
        "HomePageController/getHomePageZoneCountrys"
      );
      if (code === 0) {
        this.countrysYuanqu = data; //下拉值
      }
    },
    //geo纬度值
    async loadgeoCoordMapdataCGIT() {
      const { code, data } = await api.get("HomePageController/getGeoMapData", {
        dbType: 1,
        dbId: 1,
        year: 2019,
      });
      if (code === 0) {
        this.geoCoordMapdataCGIT = data;
        for (let key in this.geoCoordMapdataCGIT) {
          let coordX = this.geoCoordMapdataCGIT[key][0];
          if (coordX <= -30) {
            this.geoCoordMapdataCGIT[key][0] = 360 + coordX;
          }
        }
      }
    },
    async loadgeoCoordMapdataTrade() {
      const { code, data } = await api.get("HomePageController/getGeoMapData", {
        dbType: 2,
        dbId: 1,
        year: 2019,
      });
      if (code === 0) {
        this.geoCoordMapdataTrade = data;
        for (let key in this.geoCoordMapdataTrade) {
          let coordX = this.geoCoordMapdataTrade[key][0];
          if (coordX <= -30) {
            this.geoCoordMapdataTrade[key][0] = 360 + coordX;
          }
        }
      }
    },
    async loadgeoCoordMapdataYuanqu() {
      const { code, data } = await api.get("HomePageController/getGeoMapData", {
        dbType: 3,
        dbId: 1,
        year: 2019,
      });
      if (code === 0) {
        this.geoCoordMapdataYuanqu = data;
        for (let key in this.geoCoordMapdataYuanqu) {
          let coordX = this.geoCoordMapdataYuanqu[key][0];
          if (coordX <= -30) {
            this.geoCoordMapdataYuanqu[key][0] = 360 + coordX;
          }
        }
      }
    },
    // 分布图的汉英对应
    async loadnameMapdata() {
      const { code, data } = await api.get("/HomePageController/getCountryMap");
      if (code === 0) {
        this.nameMap = data;
      }
    },
    //cgit流向图
    async drawcgitMap() {
      const { code, data } = await api.post("HomePageController/getTradeInfo", {
        country: this.countryid,
        dbId: 1,
        greenField: 0,
        quantity: 0,
        sector: 0,
        shareSize: 0,
        year: 0,
      });
      if (code === 0) {
        this.CGITworldData = data;
      }

      let chartmap = this.$echarts.init(document.getElementById("mainmap"));
      //随屏幕大小缩放
      window.onresize = () => {
        chartmap.resize();
      };
      this.mainmap = this.$echarts.init(this.$refs.mainmap);
      initCGITmap(this.mainmap, this.CGITworldData, this.geoCoordMapdataCGIT); //indexworldmap.js
    },
    loadcgitmap() {
      $("#map1").find("p").css({ color: "#e6c44e" });
      $("#map1").siblings().find("p").css("color", "#34c4fe");
      $("#map1").find("a").css("box-shadow", "0px 0px 7px #d9d9d9");
      $("#map1").siblings().find("a").css("box-shadow", "0px 0px 0px #d9d9d9");
      this.isLengedCGIT = true;
      (this.isLenged = false), (this.isPowerIndicators = false);
      this.countryid = "";
      this.countrys = this.countrysCgit;
      this.countrysCgitvalue = "";
      this.maptodb = "db/cgit";
      this.maptitle = "中国对外直接投资";
      this.drawcgitMap();
    },
    //对外贸易库流向图
    async drawtradeMap() {
      const { code, data } = await api.get("/HomePageController/getFlowMap", {
        // timeId: 2019,
        regionName: "全国",
        ioreName: this.iorename,
        stateName: this.countryid,
        queryType: 0,
      });
      if (code === 0) {
        this.TradeworldData = data;
      }
      this.mainmap = this.$echarts.init(this.$refs.mainmap);
      initTrademap(
        this.mainmap,
        this.TradeworldData,
        this.geoCoordMapdataTrade
      ); //indexworldmap.js
    },
    loadtrademap() {
      $("#map2").find("p").css("color", "#e6c44e");
      $("#map2").siblings().find("p").css("color", "#34c4fe");
      $("#map2").find("a").css("box-shadow", "0px 0px 7px #d9d9d9");
      $("#map2").siblings().find("a").css("box-shadow", "0px 0px 0px #d9d9d9");
      this.isLenged = true;
      this.isLengedCGIT = false;
      this.isPowerIndicators = false;
      this.countryid = "全部经济体";
      this.countrys = this.countrysTrade;
      this.countrysCgitvalue = "";
      this.maptodb = "db/trade";
      this.maptitle = "中国货物贸易出口";
      this.drawtradeMap();
    },
    //政治库
    async drawpoliticsMap() {
      const { code, data } = await api.get(
        "/HomePageController/getDataByCountry",
        {
          indicatorId: 4,
          countryIds: this.countryid,
        }
      );
      if (code === 0) {
        this.PoliticsworldData = data;
        var Politicstitle = this.maptitle;
      }

      this.mainmap = this.$echarts.init(this.$refs.mainmap);
      initPoliticsmap(this.mainmap, Politicstitle, this.PoliticsworldData, this.nameMap); //indexworldmap.js
    },
    loadpoliticsmap() {
      $("#map3").find("p").css("color", "#e6c44e");
      $("#map3").siblings().find("p").css("color", "#34c4fe");
      $("#map3").find("a").css("box-shadow", "0px 0px 7px #d9d9d9");
      $("#map3").siblings().find("a").css("box-shadow", "0px 0px 0px #d9d9d9");
      this.isLenged = false;
      this.isLengedCGIT = false;
      this.isPowerIndicators = true;
      this.countryid = "0";
      this.countrys = this.countrysPolitics;
      this.countrysCgitvalue = "";
      this.maptodb = "db/politics/GIS";
      this.maptitle = "政府首脑的产生方式";
      this.drawpoliticsMap();
    },
    //营商库
    // async drawbusinessMap() {
    //   if (this.countryid == "") this.countryid = -1;
    //   const { code, data } = await api.get(
    //     "/HomePageController/getHomePageMapInfo",
    //     {
    //       indicatorName: "总体",
    //       timeName: 0,
    //       stateIds: this.countryid,
    //     }
    //   );
    //   if (code === 0) {
    //     this.DbusinessworldData = data;
    //   }

    //   this.mainmap = this.$echarts.init(this.$refs.mainmap);
    //   initBusinessmap(this.mainmap, this.DbusinessworldData, this.nameMap); //indexworldmap.js
    // },

    // https://ydyl.drcnet.com.cn/ydylapi/HomePageController/getHomePageMapInfo2?timeName=0&stateIds=-1&indicatorId=1
    async drawbusinessMap() {
      if (this.countryid == "") this.countryid = -1;

      const { code, data } = await api.get(
        "/HomePageController/getHomePageMapInfo2",
        {
          // indicatorName: "总体",
          timeName: 0,
          stateIds: this.countryid,
          // stateIds: -1,
          indicatorId: 1
        }
      );
      if (code === 0) {
        this.DbusinessworldData = data;
      }

      this.mainmap = this.$echarts.init(this.$refs.mainmap);
      initBusinessmap(this.mainmap, this.DbusinessworldData, this.nameMap); //indexworldmap.js
    },
    loadbusinessmap() {
      $("#map4").find("p").css("color", "#e6c44e");
      $("#map4").siblings().find("p").css("color", "#34c4fe");
      $("#map4").find("a").css("box-shadow", "0px 0px 7px #d9d9d9");
      $("#map4").siblings().find("a").css("box-shadow", "0px 0px 0px #d9d9d9");
      this.isLenged = false;
      this.isLengedCGIT = false;
      this.isPowerIndicators = false;
      this.countryid = -1;
      this.countrys = this.countrysDbusiness;
      this.countrysCgitvalue = [];
      // this.maptodb = "db/DbusinessF";
      this.maptodb = "db/Pillar";
      this.maptitle = "世行营商环境成熟度（B-READY）指标";
      // this.maptitle = "世界各国营商便利度得分";
      this.drawbusinessMap();
    },
    //园区库
    async drawyuanquMap() {
      const { code, data } = await api.get(
        "/HomePageController/getZoneMapBySelected",
        {
          countryIds: this.countryid,
        }
      );
      if (code === 0) {
        this.YuanworldData = data;
      }
      this.mainmap = this.$echarts.init(this.$refs.mainmap);
      initYuanqumap(
        this.mainmap,
        this.YuanworldData,
        this.geoCoordMapdataYuanqu
      ); //indexworldmap.js
    },
    loadyuanqumap() {
      $("#map5").find("p").css("color", "#e6c44e");
      $("#map5").siblings().find("p").css("color", "#34c4fe");
      $("#map5").find("a").css("box-shadow", "0px 0px 7px #d9d9d9");
      $("#map5").siblings().find("a").css("box-shadow", "0px 0px 0px #d9d9d9");
      this.isLenged = false;
      this.isLengedCGIT = false;
      this.isPowerIndicators = false;
      this.countryid = 0;
      this.countrys = this.countrysYuanqu;
      this.countrysCgitvalue = "";
      this.maptodb = "lit/list?uid=8012";
      this.maptitle = "中国境外经贸合作区";
      this.drawyuanquMap();
    },
    //右上1栏目样式
    changerightpart1li(index, tabname) {
      this.rightpart1tabindex = index;
      $("#part1li" + index)
        .find("a")
        .addClass("btn_a_on");
      $("#part1li" + index)
        .siblings()
        .find("a")
        .removeClass("btn_a_on");
      //将当前div(ul)显示，其它div(ul)隐藏
      $(".rightpart1div")
        .eq(index - 1)
        .show()
        .siblings("div")
        .hide();

      //报告bg、资讯zx、案例al、推荐tj
      if (tabname == "bg") {
        this.rightpart1tab = "bg";
      } else if (tabname == "zx") {
        this.rightpart1tab = "zx";
      } else if (tabname == "al") {
        this.rightpart1tab = "al";
      } else if (tabname == "tj") {
        this.rightpart1tab = "tj";
      }
      // this.loadpagescroll();
    },
    //右上2栏目样式
    changerightpart2li(index, tabname) {
      //省市ss、国家gb
      if (tabname == "ss") {
        this.rightpart2tab = "ss";
        $("#part2li1").find("a").addClass("btn_b_on");
        $("#part2li2").find("a").removeClass("btn_a_on");
      } else if (tabname == "gb") {
        this.rightpart2tab = "gb";
        $("#part2li2").find("a").addClass("btn_a_on");
        $("#part2li1").find("a").removeClass("btn_b_on");
      }
    },
    //右2上翻（已注销）
    rightpart2top() {
      if (this.rightpart2tab == "ss") {
        if (this.rightpart2_1x1 != 0) {
          this.rightpart2_1x1 = this.rightpart2_1x1 - 1;
          this.rightpart2_1x2 = this.rightpart2_1x2 - 1;

          this.part2_1CurrentValue = this.part2_1Value.slice(
            this.rightpart2_1x1,
            this.rightpart2_1x2
          );
          this.part2_1CurrentData = this.part2_1Data.slice(
            this.rightpart2_1x1,
            this.rightpart2_1x2
          );
          this.chart2_1.series[0].data = this.part2_1CurrentValue.reverse();
          this.chart2_1.yAxis[0].data = this.part2_1CurrentData.reverse();
        } else {
          return false;
        }
      } else if (this.rightpart2tab == "gb") {
        if (this.rightpart2_2x1 != 0) {
          this.rightpart2_2x1 = this.rightpart2_2x1 - 1;
          this.rightpart2_2x2 = this.rightpart2_2x2 - 1;

          this.part2_2CurrentValue = this.part2_2Value.slice(
            this.rightpart2_2x1,
            this.rightpart2_2x2
          );
          this.part2_2CurrentData = this.part2_2Data.slice(
            this.rightpart2_2x1,
            this.rightpart2_2x2
          );
          this.chart2_2.series[0].data = this.part2_2CurrentValue.reverse();
          this.chart2_2.yAxis[0].data = this.part2_2CurrentData.reverse();
        } else {
          return false;
        }
      }
    },
    //右2下翻（已注销）
    rightpart2down() {
      //省市
      if (this.rightpart2tab == "ss") {
        if (this.rightpart2_1x2 < this.part2_1Data.length) {
          this.rightpart2_1x1 = this.rightpart2_1x1 + 1;
          this.rightpart2_1x2 = this.rightpart2_1x2 + 1;

          this.part2_1CurrentValue = this.part2_1Value.slice(
            this.rightpart2_1x1,
            this.rightpart2_1x2
          );
          this.part2_1CurrentData = this.part2_1Data.slice(
            this.rightpart2_1x1,
            this.rightpart2_1x2
          );
          this.chart2_1.series[0].data = this.part2_1CurrentValue.reverse();
          this.chart2_1.yAxis[0].data = this.part2_1CurrentData.reverse();
        } else {
          return false;
        }
        //国别
      } else if (this.rightpart2tab == "gb") {
        if (this.rightpart2_2x2 < this.part2_2Data.length) {
          this.rightpart2_2x1 = this.rightpart2_2x1 + 1;
          this.rightpart2_2x2 = this.rightpart2_2x2 + 1;

          this.part2_2CurrentValue = this.part2_2Value.slice(
            this.rightpart2_2x1,
            this.rightpart2_2x2
          );
          this.part2_2CurrentData = this.part2_2Data.slice(
            this.rightpart2_2x1,
            this.rightpart2_2x2
          );
          this.chart2_2.series[0].data = this.part2_2CurrentValue.reverse();
          this.chart2_2.yAxis[0].data = this.part2_2CurrentData.reverse();
        } else {
          return false;
        }
      }
    },
    //右2省市
    async getCityZoneList() {
      const { code, data } = await api.get(
        "/HomePageController/getCityZoneList",
        {
          pageIndex: 1,
          pageSize: 0,
        }
      );
      if (code === 0) {
        this.part2_1Value = data.cityData.values;
        this.part2_1Data = data.cityData.citys;
        this.part2_1Datasub = data.stateData;

        //当前显示的5条(按下标截取)
        // this.part2_1CurrentValue = this.part2_1Value.slice(
        //   this.rightpart2_1x1,
        //   this.rightpart2_1x2
        // );
        // //当前显示的5条(按下标截取)
        // this.part2_1CurrentData = this.part2_1Data.slice(
        //   this.rightpart2_1x1,
        //   this.rightpart2_1x2
        // );
        //绑定
        // this.chart2_1.series[0].data = this.part2_1CurrentValue.reverse();
        // this.chart2_1.yAxis[0].data = this.part2_1CurrentData.reverse();
        this.chart2_1.series[0].data = this.part2_1Value.reverse();
        this.chart2_1.yAxis[0].data = this.part2_1Data.reverse();
        //因提出需要翻页后柱图有基数，因此这样处理(每5根设置该区域最大值)
        // this.part2_1max = data.cityData.values[0];
        // this.chart2_1.series[1].data = [
        //   this.part2_1max,
        //   this.part2_1max,
        //   this.part2_1max,
        //   this.part2_1max,
        //   this.part2_1max
        // ];

        //右2省市下钻
        let chart2_1 = this.$echarts.init(document.getElementById("chart2_1"));
        let chart2 = this.$echarts.init(document.getElementById("chart2"));

        chart2_1.on("mouseover", (params) => {
          let ssname = params.name;
          this.part2_1Datasub.forEach((item) => {
            if (item.name === ssname) {
              let ssnamenew = "";
              if (ssname == "北京" || ssname == "天津" || ssname == "上海") {
                ssnamenew = ssname + "市";
              } else if (ssname == "内蒙古") {
                ssnamenew = ssname + "自治区";
              } else if (ssname == "新疆") {
                ssnamenew = ssname + "维吾尔自治区";
              } else if (ssname == "广西") {
                ssnamenew = ssname + "壮族自治区";
              } else if (ssname == "央企") {
                ssnamenew = ssname;
              } else {
                ssnamenew = ssname + "省";
              }

              let yuanquData1 = 0;
              item.data.forEach((ele) => {
                yuanquData1 += ele.value;
              });
              this.chart2.title[0].text =
                ssnamenew + "境外经贸合作园区分布(共" + yuanquData1 + "个园区)";
              this.chart2.series[0].data = item.data;
              this.boxDisplay = "block";
              chart2.setOption(this.chart2);
            }
          });
        });
      }
    },
    //右2国家
    async getCountryZoneList() {
      const { code, data } = await api.get(
        "/HomePageController/getCountryZoneList",
        {
          pageIndex: 1,
          pageSize: 0,
        }
      );
      if (code === 0) {
        this.part2_2Value = data.countryData.values;
        this.part2_2Data = data.countryData.countrys;
        this.part2_2Datasub = data.cityData;
        // this.part2_2CurrentValue = this.part2_2Value.slice(
        //   this.rightpart2_2x1,
        //   this.rightpart2_2x2
        // );
        // this.part2_2CurrentData = this.part2_2Data.slice(
        //   this.rightpart2_2x1,
        //   this.rightpart2_2x2
        // );
        // this.chart2_2.series[0].data = this.part2_2CurrentValue.reverse();
        // this.chart2_2.yAxis[0].data = this.part2_2CurrentData.reverse();
        this.chart2_2.series[0].data = this.part2_2Value.reverse();
        this.chart2_2.yAxis[0].data = this.part2_2Data.reverse();

        // this.part2_2max = data.countryData.values[0];
        // this.chart2_2.series[1].data = [
        //   this.part2_2max,
        //   this.part2_2max,
        //   this.part2_2max,
        //   this.part2_2max,
        //   this.part2_2max
        // ];

        //右2国家下钻
        let chart2_2 = this.$echarts.init(document.getElementById("chart2_2"));
        let chart2 = this.$echarts.init(document.getElementById("chart2"));
        chart2_2.on("mouseover", (params) => {
          let gbname = params.name;
          this.part2_2Datasub.forEach((item) => {
            if (item.name === gbname) {
              let yuanquData2 = 0;
              item.data.forEach((ele) => {
                yuanquData2 += ele.value;
              });
              this.chart2.title[0].text =
                "中国各省市在" +
                gbname +
                "的境外经贸合作园区分布\n(共" +
                yuanquData2 +
                "个园区)";
              this.chart2.series[0].data = item.data;
              this.boxDisplay = "block";
              chart2.setOption(this.chart2);
            }
          });
        });
      }
    },
    //柱图下钻弹出框关闭
    closeAlert() {
      this.boxDisplay = "none";
    },
    //右3热搜词
    async wordsByWebChannels() {
      const { code, data } = await api.get(
        "/HomePageController/wordsByWebChannels",
        {
          uid: "80",
          interval: 15,
          showCount: 200,
        }
      );
      if (code === 0) {
        this.optionworldcloud.series[0].data = data;

        //点击热搜词搜索
        let worldcloud = this.$echarts.init(
          document.getElementById("worldcloud")
        );
        worldcloud.on("click", (params) => {
          window.open(
            "http://s1.drcnet.com.cn/search/SearchAC.aspx?chnId=5713&fields=3^1^1^" +
            escape(params.name),
            "Search"
          );
        });
      }
    },
    commonWatch(val, oldval, value) {
      let newindex = val.indexOf(value),
        oldindex = oldval.indexOf(value);
      //获取val和oldval里0的索引,如果没有则返回-1
      if (newindex != -1 && oldindex == -1 && val.length > 1)
        //如果新的选择里有勾选了选择所有选择所有 则 只直线勾选所有整个选项
        this.countrysCgitvalue = [value];
      else if (newindex != -1 && oldindex != -1 && val.length > 1)
        //如果操作前有勾选了选择所有且当前也选中了勾选所有且勾选数量大于1  则移除掉勾选所有
        this.countrysCgitvalue.splice(val.indexOf(value), 1);
      //储存当前最后的结果 作为下次的老数据
      this.countryid = this.countrysCgitvalue.toString(); //给下拉赋选择的值
    },
  },

  watch: {
    countrysCgitvalue: function (val, oldval) {
      if (this.maptitle === "中国对外直接投资") {
        this.commonWatch(val, oldval, 0);
        this.drawcgitMap();
      } else if (this.maptitle === "中国货物贸易出口") {
        this.commonWatch(val, oldval, "全部经济体");
        this.drawtradeMap();
      } else if (this.maptitle === "政府首脑的产生方式") {
        this.commonWatch(val, oldval, "0");
        this.countrysCgitvalue === "" ? (this.countryid = 0) : this.countryid;
        this.drawpoliticsMap();
        // } else if (this.maptitle === "世界各国营商便利度得分") {
      } else if (this.maptitle === "世行营商环境成熟度（B-READY）指标") {
        // this.commonWatch(val, oldval, "-1");
        this.countryid = val.length > 0 ? val.toString() : -1;
        this.drawbusinessMap();
      } else if (this.maptitle === "中国境外经贸合作区") {
        this.commonWatch(val, oldval, 0);
        this.countrysCgitvalue === "" ? (this.countryid = 0) : this.countryid;
        this.drawyuanquMap();
      }
    },
  },
};
</script>

<style>
/* 浏览器提示语 */
/* @import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.11.2/css/all.min.css"; */
/* @import "../assets/css/tip/bootstrap.min.css"; */
@import "../assets/css/tip/font-awesome-animation.min.css";
@import "../assets/css/tip/style.css";

/* 飘窗 */
.window {
  position: fixed;
  z-index: 9999;
  right: 0px;
  bottom: 10px;
}

.close {
  height: 20px;
  width: 20px;
  background: transparent;
  top: 5px;
  position: absolute;
  right: 5px;
  cursor: pointer;
  color: #fff;
  font-weight: 400;
}

.close:hover {
  color: #0396ff;
}

/* 右2省市---开始 */
.title_right_box {
  position: relative;
  height: 100%;
}

.provinces {
  height: 100%;
  padding-top: 40px;
}

/* 滚动条 */
.provincesq::-webkit-scrollbar {
  width: 10px;
  height: 20px;
}

.provincesq::-webkit-scrollbar-thumb {
  background: #0e7fe1;
  border-radius: 5px;
}

.provincesq::-webkit-scrollbar-track {
  background: #063170;
  border-radius: 5px;
}

/* 针对IE的scrollbar */
.provincesq {
  scrollbar-face-color: #0e7fe1;
  /*3D表面（ThreedFace）*/
  scrollbar-highlight-color: #063170;
  /*3D界面的亮边（ThreedHighlight）*/
  scrollbar-shadow-color: #063170;
  /*3D界面的暗边（ThreedShadow）*/
  scrollbar-3dlight-color: #063170;
  /*亮边框*/
  scrollbar-arrow-color: #0e7fe1;
  /*方向箭头 */
  scrollbar-track-color: #063170;
  /*拖动区域(TrackBar)*/
  scrollbar-darkshadow-color: #063170;
  /*暗边框（ThreedDarkShadow）*/
}

/* 针对firefox的scrollbar */
.provincesq {
  scrollbar-color: #0e7fe1 #063170;
  scrollbar-width: thin;
}

/* 右2省市---结束 */

/* 头部select更改 */
#topbox .topselect {
  color: #6c757d;
  background: rgba(5, 14, 60, 0.6) !important;
  background-clip: padding-box;
  border: 1px solid #ffae00;
  left: -0px !important;
}

#topbox .topselect .el-select-dropdown__item {
  background-color: transparent !important;
  text-align: center !important;
}

#topbox .topselect .el-select-dropdown__item:hover {
  background-color: #ffefcc !important;
}

#topbox .topselect .el-select-dropdown__item.selected {
  background-color: #ffefcc !important;
  color: #ffae00 !important;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  background-color: #ffefcc !important;
}
</style>
<style lang='less' scoped>
body {
  font-family: "微软雅黑", "Heiti SC", "黑体", "Arial" !important;
  color: #202223;
  margin: 0 auto;
  cursor: default;
  word-break: break-all;
  white-space: normal;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  letter-spacing: 0.2px;
}

.mb {
  margin: 3vh 2vh;
}

.bj {
  background: transparent url(../assets/imgs/bj.jpg) top center no-repeat fixed;
  position: relative;
  display: block;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  -webkit-transition: opacity 0.4s;
  -moz-transition: opacity 0.4s;
  transition: opacity 0.4s;
  height: 100vh;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;

  // 头部
  .header_bj {
    background: rgba(7, 60, 120, 0.5);
    position: absolute;
    height: 60px;
    width: 100%;
    z-index: 9999;
  }

  .sy_header_bj {
    height: 60px;
    width: 100%;
    background: rgba(7, 60, 120, 0.5);

    .nav-left {
      height: 60px;

      .menu-con {
        width: 60px;
        height: 60px;
        border-right: 1px solid #001035;
        text-align: center;
        line-height: 60px;

        .menu-ico {
          width: 60px;
          height: 60px;
          text-align: center;
          cursor: pointer;

          i {
            display: inline-block;
            margin-top: 18px;
            width: 24px;
            height: 24px;
            background: url(../assets/imgs/menu-ico.png) no-repeat 0 2px;
            transition: all 0.2s ease-in;
          }
        }

        .nav-cd {
          position: absolute;
          top: 60px;
          z-index: 2000;
          color: #333333;

          .leve01 {
            width: 170px;
            height: 100%;
            background: rgba(32, 96, 168, 0.97);
            padding-bottom: 15px;
            box-sizing: border-box;
            position: fixed;
            top: 60px;

            .leve01-li {
              color: #fff;
            }
          }
        }
      }

      .park-logo {
        margin-top: 12px;
        margin-left: 14px;
      }
    }

    .nav-right {

      // 右侧信息
      .nav-lists2 {
        color: #8493e6;

        .list {
          position: relative;
          padding: 0 8px;
          z-index: 2;
          cursor: pointer;

          .nav-item {
            display: inline-block;
            height: 60px;
            line-height: 60px;
            font-size: 14px;
            color: #fff;
            opacity: 0.6;
            filter: alpha(opacity=60);
            cursor: pointer;
          }
        }
      }
    }
  }

  // 主体
  .indexmain {
    flex: 1;
    width: 100%;
    padding-top: 60px;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.05);

    // 左侧
    .leftmain {
      width: 100%;
      height: 100%;
      position: absolute;
      padding: 30px;
      padding-right: 570px;

      //左侧头部
      .clearfix {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        height: 6.66vh;

        .middle_top {
          color: #7bd1fd;
          font-size: 0.16rem;
          display: flex;
          justify-content: space-around;

          .fl {
            .list_title {
              font-weight: 600;
              text-align: left;
            }

            .list_title_color {
              color: #7bd1fd;
              font-weight: 600;
              white-space: nowrap;
            }

            .list_title_color:hover {
              color: #e6c44e;
            }

            .list_num {
              .counter-value {
                color: #e6c44e;
                font-weight: 600;
                font-size: 0.23rem;
              }

              span {
                // color: #fff;
                // padding-top: 7px;
                // display: block;
                // float: left;
                // padding-left: 3px;
                font-size: 0.15rem;
              }
            }
          }

          .line {
            padding: 0.2rem 0.17rem 0.15rem 0.17rem;
          }
        }
      }

      // 世界地图
      .map_box {
        position: relative;
        height: 60.5vh;

        .map_title {
          background: url(../assets/imgs/titlehj1.png) no-repeat center;
          height: 38px;
          line-height: 38px;
          text-align: center;
          width: 423px;
          color: #fff;
          font-size: 18px;
          letter-spacing: 1px;
          margin: 0 auto;
          margin-top: 10px;

          .map_title_a {
            color: #fff;
          }

          .map_title_a:hover {
            color: rgb(230, 196, 78);
          }
        }

        .box_sx {
          float: right;
          margin-top: 10px;
        }

        .box_sx li {
          float: left;
          color: #fff;
          line-height: 25px;
          margin-left: 10px;
        }

        .map_main {
          padding-top: 38px;
          margin-bottom: 10px;
        }
      }

      .bottomleft {
        height: 13vh;
        position: relative;
        margin-top: 0.05rem;

        ul li a p {
          font-size: 0.14rem;
        }
      }

      // .perch {
      //   position: relative;
      //   height: 21vh;
      // }
    }

    // 右侧
    .rightmain {
      position: absolute;
      right: 10px;

      .background_border {
        background: url(../assets/imgs/bkimg.png) no-repeat top;
        width: 500px;
        height: 26.5vh;
        background-size: 100% 100%;
        padding: 30px 20px 20px 20px;

        // 1
        ul {
          .btn_a {
            color: #fff;
            display: block;
            width: 60px;
            height: 30px;
            margin-right: 10px;
            background: url(../assets/imgs/btnbj2.png) no-repeat center;
            line-height: 30px;
            text-align: center;
          }

          .btn_a:hover {
            background: url(../assets/imgs/btnbj1.png) no-repeat center;
          }

          .btn_a_on {
            background: url(../assets/imgs/btnbj1.png) no-repeat center;
          }

          .btn_b {
            color: #fff;
            display: block;
            width: 90px;
            height: 30px;
            margin-right: 10px;
            background: url(../assets/imgs/btnbj4.png) no-repeat center;
            line-height: 30px;
            text-align: center;
          }

          .btn_b:hover {
            background: url(../assets/imgs/btnbj3.png) no-repeat center;
          }

          .btn_b_on {
            background: url(../assets/imgs/btnbj3.png) no-repeat center;
          }
        }

        .pageup {
          a {
            float: left;
            padding-left: 7px;
            padding-top: 3px;
          }
        }

        .two_ul {
          padding-top: 15px;

          .two_li {
            line-height: 35px;
            height: 35px;
            zoom: 1;

            .a_tiile {
              color: #f1f7fe;
              width: 82.5%;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              text-align: left;
            }

            span {
              color: #107dbf;
            }
          }
        }

        // 2
        .provinces {
          // padding-top: 0.15rem;
          // height: 14vh;
          // overflow-y: auto;
          // overflow-x: hidden;
        }

        // .provinces::-webkit-scrollbar {
        //   /*滚动条整体样式*/
        //   width: 13px; /*高宽分别对应横竖滚动条的尺寸*/
        //   height: 1px;
        // }
        // .provinces::-webkit-scrollbar-thumb {
        //   /*滚动条里面小方块*/
        //   border-radius: 5px;
        //   box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        //   background: #0f52a6;
        // }
        // .provinces::-webkit-scrollbar-track {
        //   /*滚动条里面轨道*/
        //   border-radius: 5px;
        //   box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        //   background: #11204b;
        // }

        // 3
        .title_h2 {
          background: url(../assets/imgs/icon_a1.png) no-repeat 0 10px;
          height: 30px;
          line-height: 30px;
          padding-left: 23px;
          padding-right: 10px;

          h2 {
            color: #fff;
            font-size: 15px;
            height: 30px;
            line-height: 30px;
          }
        }

        .rsc_box {
          padding-top: 32px;
          height: 100%;
        }
      }
    }
  }
}

//数字滚动
/deep/.list_num_bg span {
  color: #fff;
  padding-top: 0.07rem;
  display: block;
  float: left;
  padding-left: 0.03rem;
  font-size: 0.15rem;
}

/deep/.unit {
  color: #fff;
  padding-top: 0.07rem;
  display: block;
  float: left;
  padding-left: 0.03rem;
  font-size: 0.15rem;
}

/deep/.span_bj .spanbj {
  background: url(../assets/imgs/number.png) no-repeat center;
  width: 0.17rem;
  margin-right: 0.02rem;
  height: 0.21rem;
  padding: 0;
  text-align: center;
  font-size: 0.2rem !important;
  line-height: 0.2rem;
  margin-top: 0.06rem !important;
}

//地图
.tab_map li a {
  color: #34c4fe;
  display: block;
  float: left;
  text-align: center;
  width: 20%;
  // padding: 0 10px;
  padding: 0 5px;
  margin-top: 20px;
}

.tab_map li a:hover {
  box-shadow: 0px 0px 7px #d9d9d9;
}

//地图条件选择
/deep/.btn-light {
  display: inline-block;
  font-weight: 400;
  color: #34c4fe;
  text-align: left;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  border: 1px solid #34c4fe;
  padding: 0 10px;
  width: 140px;
  border-radius: 100px;
  font-size: 0.875rem;
  line-height: 25px;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

// rightpart1
//上翻下翻
.panel-footer {
  display: none;
}

.glyphicon-chevron-down:before {
  content: "\e114";
  color: red;
}

.glyphicon-chevron-up::before {
  content: "\e113";
  color: red;
}

/* 柱图下钻弹出框 */
.content {
  width: 100%;
  height: 100%;
  position: relative;
}

.historySupBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  z-index: 99999;
}

.maskBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 1);
  opacity: 0.15;
  -khtml-opacity: 0.15;
  -moz-opacity: 0.15;
  -webkit-opacity: 0.15;
}

.historyAlertBox {
  width: 400px;
  height: 225px;
  position: fixed;
  top: 72%;
  left: 82%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0) url(../assets/imgs/bj.jpg) repeat scroll 0% 0%;
  border: 1px solid rgba(62, 139, 255, 0.59);
}

.indexmain a {
  cursor: pointer;
}

.rightpart1div {
  height: 16vh;
  overflow-y: hidden;
  /* 必要元素 */
}

//地图右上搜索
.dropdown {
  /deep/.homeselect {
    background: rgba(5, 14, 60, 0.8) !important;
    border: 1px solid #40b7ff;
  }

  /deep/.el-select-dropdown__list {
    overflow: hidden;
  }

  /deep/.el-select-dropdown__item {
    float: none !important;
    margin-left: 0px !important;
    height: 34px !important;
    line-height: 34px !important;
    text-align: left;
    color: #0b98d0 !important;
    font-size: 14px;
    padding: 0 20px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #606266;
    cursor: pointer;
  }

  /deep/.el-input__inner {
    display: inline-block;
    font-weight: 400;
    color: #34c4fe;
    text-align: left;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid rgb(52, 196, 254);
    padding: 0 10px;
    // width: 140px;
    width: 204px;
    border-radius: 100px;
    // font-size: 0.875rem;
    line-height: 25px;
    -webkit-transition: color 0.15s ease-in-out,
      background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
      -webkit-box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
      -webkit-box-shadow 0.15s ease-in-out;
    background: #071a4a url(../assets/imgs/drop-down3.png) no-repeat 172px 3px;
    padding-right: 10px;
    position: relative;
    z-index: 100;
    height: 27px;
  }

  /deep/.el-popper[x-placement^="bottom"] .popper__arrow::after {
    top: 0px;
    border-bottom-color: #34c4fe;
  }

  /deep/ .el-select__tags {
    max-width: 204px !important;
    z-index: 9999 !important;
  }

  /deep/ .el-tag.el-tag--info {
    background-color: transparent !important;
    border: none !important;
  }

  /deep/ .el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
    background-color: #8dd1fc !important;
  }

  /deep/.el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background: none !important;
    background-color: transparent !important;
  }
}

.indexmain {
  position: relative;
}

.PowerIndicators {
  border: 1px solid #34c4fe;
  border-radius: 25%;
  padding: 5px 10px;
  color: #fff;
  float: left;
  margin-right: 1.5vw;
}

.PowerIndicators:hover {
  color: #34c4fe;
}

// 搜索框
/deep/.search {
  border: 1px solid #ffae00;
  background-color: #fff;

  .sslist {
    border-right: 1px solid #ffae00;
  }

  .el-input__inner {
    color: #ffae00;
    font-weight: 700;
    background: #fff;
    line-height: 33px;
  }

  .el-input__suffix {
    z-index: 999;
  }

  .el-select-dropdown__item {
    color: #ffae00;
  }

  #topbox .topselect /deep/.el-select-dropdown__item {
    color: #ffae00 !important;
  }

  .el-popper[x-placement^="bottom"] .popper__arrow {
    border-bottom-color: #ffae00;
  }

  .el-popper[x-placement^="bottom"] .popper__arrow::after {
    border-bottom-color: rgba(5, 14, 60, 0.6);
  }
}

/deep/.searchbtna {
  background: orange;
}
</style>
